import { render, staticRenderFns } from "./PatientForm.vue?vue&type=template&id=a7eb9906&scoped=true&"
import script from "./PatientForm.vue?vue&type=script&lang=ts&"
export * from "./PatientForm.vue?vue&type=script&lang=ts&"
import style0 from "./PatientForm.vue?vue&type=style&index=0&id=a7eb9906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7eb9906",
  null
  
)

export default component.exports